import { Checkbox, SkeletonText, Tag } from "@carbon/react";
import {
  MaterialCompaniesOpportunitiesResponse,
  OrderToSubmitRequest,
  MaterialCompaniesPaginatedOpportunitiesResponse,
} from "../../../types";
import i18next from "../../../i18n";
import Pagination from "../../../components/UI/Pagination/Pagination";
import { getCompanyLegalAddressLabel } from "../../../utils/address";

type PotentialSuppliersSectionProps = {
  potentialSuppliers: MaterialCompaniesPaginatedOpportunitiesResponse;
  ordersToSubmit: OrderToSubmitRequest[];
  selectedComplexType: any;
  materialId: string;
  isLoading?: boolean;
  handleOrdersToSubmit: (invite: any, type?: string) => void;
  potentialSuppliersPage: number;
  setPotentialSuppliersPage: (page: number) => void;
};

const PotentialSuppliersSection = ({
  potentialSuppliers,
  ordersToSubmit,
  selectedComplexType,
  materialId,
  isLoading = false,
  handleOrdersToSubmit,
  potentialSuppliersPage,
  setPotentialSuppliersPage,
}: PotentialSuppliersSectionProps) => {
  if (
    !isLoading &&
    (!potentialSuppliers?.content || potentialSuppliers.content.length === 0)
  ) {
    return null;
  }

  const handlePotentialSupplierSelection = (
    supplier: MaterialCompaniesOpportunitiesResponse
  ) => {
    const supplierData = {
      materialId: selectedComplexType?.value === "JOINT" ? "ALL" : materialId,
      supplierId: supplier.user.id,
      supplierInfo: {
        id: supplier.user.id,
        email: supplier.user.email,
        name: `${supplier.user.firstName || ""} ${supplier.user.lastName || ""}`.trim(),
        companyName: supplier.user.company?.name || "",
      },
    };

    const currentMaterialOrder = ordersToSubmit.find(
      (order: any) => order.id === materialId
    );
    const isSelected =
      currentMaterialOrder?.suppliers.some(
        (sup: any) => sup.id === supplier.user.id
      ) || false;

    handleOrdersToSubmit(
      supplierData,
      isSelected ? "removeExistingSupplier" : "existingSupplier"
    );
  };

  return (
    <div className="order-supplier-group">
      <div className="order-supplier-subhead">
        {i18next.t("material.potencialSuppliers") || "Potential Suppliers"}
        {!isLoading && !!potentialSuppliers?.totalElements && (
          <Tag type="blue" size="sm">
            {potentialSuppliers.totalElements}
          </Tag>
        )}
      </div>

      {isLoading ? (
        <SkeletonText paragraph lineCount={3} />
      ) : (
        potentialSuppliers.content
          .filter((supplier: MaterialCompaniesOpportunitiesResponse) => {
            const currentMaterialOrder = ordersToSubmit.find(
              (order: any) => order.id === materialId
            );
            const isAlreadySelected =
              currentMaterialOrder?.suppliers.some(
                (sup: any) => sup.id === supplier.user.id
              ) || false;
            return !isAlreadySelected;
          })
          .map((supplier: MaterialCompaniesOpportunitiesResponse) => {
            const address = getCompanyLegalAddressLabel(supplier.user.company);
            return (
              <Checkbox
                key={`${materialId}-${supplier.user.id}`}
                id={`potential-${materialId}-${supplier.user.id}`}
                checked={false}
                onChange={() => handlePotentialSupplierSelection(supplier)}
                labelText={
                  <span className="order-supplier-card__name">
                    {supplier.user.company?.name ||
                      `${supplier.user.firstName || ""} ${supplier.user.lastName || ""}`.trim()}
                    {address && (
                      <span className="order-supplier-card__addr">
                        {address}
                      </span>
                    )}
                  </span>
                }
              />
            );
          })
      )}

      {!isLoading && potentialSuppliers && (
        <Pagination
          results={potentialSuppliers.numberOfElements}
          total={potentialSuppliers.totalElements}
          amountOfPages={potentialSuppliers.totalPages}
          currentPage={potentialSuppliersPage}
          setPageNumber={setPotentialSuppliersPage}
        />
      )}
    </div>
  );
};

export default PotentialSuppliersSection;
